import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { LocationType } from '~addListing/types';

const LocationsItems = ({
  locations,
  handleSelectLocation,
  allowSelectAllLocations = false,
  hideSuggestLocation,
}: {
  locations: LocationType[];
  handleSelectLocation: (location: LocationType) => void;
  allowSelectAllLocations?: boolean;
  hideSuggestLocation?: boolean;
}) => {
  const { t } = useTranslation('app');

  return (
    <ul
      className={`overflow-y-auto pb-1.5x ${hideSuggestLocation ? 'max-h-[250px]' : 'max-h-[160px]'}  rounded-b-[16px]`}
    >
      {locations.map((location) => (
        <li
          key={location.title_full_path}
          className={`relative flex gap-x px-1.5x pt-2x pb-1.5x last:border-b-0 border-b border-gray ${allowSelectAllLocations || location.is_active ? 'hover:bg-gray_light_1 cursor-pointer' : ''}`}
          onClick={() =>
            allowSelectAllLocations || location.is_active
              ? handleSelectLocation(location)
              : undefined
          }
        >
          <Icon
            name="location"
            size="24px"
            className={`text-gray__dark_1 ${
              allowSelectAllLocations || location.is_active
                ? ''
                : 'text-opacity-45'
            }`}
          />
          <div className="flex-1">
            <p
              className={`text-body_2 text-gray__dark_2 ${
                allowSelectAllLocations || location.is_active
                  ? ''
                  : 'text-opacity-45'
              }`}
            >
              {location.title}
            </p>
            <p
              className={`text-caption text-gray__dark_1 ${
                allowSelectAllLocations || location.is_active
                  ? ''
                  : 'text-opacity-45'
              }`}
            >
              {location.title_full_path}
            </p>
          </div>
          {!allowSelectAllLocations && !location.is_active && (
            <>
              <div
                data-tip="tooltipText"
                data-tooltip-id="regionRestrictionMessage"
                data-tooltip-content={t('regionRestrictionMessage')}
                data-tooltip-place="bottom-start"
                className="h-max"
              >
                <Icon name="lock" size="24px" className="text-orange" />
              </div>
              <Tooltip
                id="regionRestrictionMessage"
                className="max-w-[272px]"
              />
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

export default LocationsItems;
